import RightPopupComponent from "components/RightPopup";


import './index.less';
import './themes/default.less';
import SpecsPanel from "../specsPanel";

export default class EditProfileDataPopup extends RightPopupComponent {


    _specs = [];
    constructor(props) {
        super(props);

        this.state = {
            ...this.state,
            info: {},
            tempPhoto: false
        };
    }

    get popupName() {
        return "editEmployeeProfilePopup";
    }

    setInfoState(key, value) {
        this.state.info[key] = value;
    }

    changeInfoState(key, value) {
        const info = this.state.info;
        info[key] = value;
        this.setState({ info });
    }

    show(info, hideCb, clinics) {

        this.state.info = { ...this.state.info, ...info };
        this.hidCb = hideCb;
        this.clinics = clinics;
        this.dialogTitle = "employee.titleEditProfileEmployee";

        this._specs = [];

        if (info.specs.length > 0) {
            this._specs = info.specs.map(it => it.specEntity);
        }


        super.show();
    }

    async onShow() {

    }

    formUpdateInfo() {

        const { info } = this.state;
        const { isDoctor, domainId, education, characteristic, experienceBeginning } = info;


        const obj = {
            isDoctor,
            domainId,
            education,
            characteristic,
            experienceBeginning
        };

        return obj;
    }


    async save() {

        const info = this.formUpdateInfo();
        this.hide();

        let spArr = [];

        if (this._specs.length > 0) {
            spArr = this._specs.map((it) => {
                return { specId: it.id, domainId: null };
            });
        }

        info.specs = spArr;

        info.isDoctor = false;

        if (info.specs.length > 0)
            info.isDoctor = true;


        if (this.hidCb?.apply)
            this.hidCb(info);

    }


    renderButtons() {
        return super.renderButtons();
    }


    onChangeSpecs(it, _status) {
        if (_status) {
            this._specs.push(it);
        } else {
            let spArr = this._specs.filter(sIt => it.id !== sIt.id);
            this._specs = spArr;
        }
    }

    getExperienceValue() {
        const { info } = this.state;
        const { experienceBeginning } = info;

        if (experienceBeginning !== null) {
            return Number(experienceBeginning.split("-")[0]);
        }

        return null;
    }

    onChangeExperience(value) {
        this.setInfoState("experienceBeginning", `${value}-01-01`);
    }
    renderContent() {

        const { info } = this.state;
        const { domainId, education, characteristic, roleId } = info;
        const hasSpec = this._helper.isRoleHasSpec(roleId);


        return (
            <div className="flex gap16 col" style={{ width: "450px" }}>

                {hasSpec &&
                    <>
                        {this.insertParagraf("employee.specsStomat")}
                        <SpecsPanel items={this._specs} onChange={this.onChangeSpecs.bind(this)} />
                    </>
                }


                <div className="flex flex1 gap16">
                    {this.insertSelect({
                        value: this.getExperienceValue(),
                        label: "employee.experienceFrom",
                        showLeftIcon: false,
                        placeHolder: "main.notIndicated",
                        translate: true,
                        items: this._helper.getEmployeeExpirienceList(),
                        onChange: this.onChangeExperience.bind(this),
                    })}
                    {this.insertSelect({
                        value: domainId,
                        label: "employee.clinicName",
                        labelKey: "fullName",
                        showLeftIcon: false,
                        placeHolder: "main.notIndicated",
                        translate: true,
                        items: this.clinics,
                        onChange: this.setInfoState.bind(this, "domainId"),
                    })}
                </div>

                <div className="inputFull">
                    {this.insertInput({
                        value: education,
                        itemStyle: "flex1",
                        label: "employee.education",
                        placeHolder: "",
                        onChange: this.setInfoState.bind(this, "education")
                    })}
                </div>

                {this.insertTextarea({
                    value: characteristic,
                    label: "employee.characteristic",
                    placeHolder: "",
                    onChange: this.setInfoState.bind(this, "characteristic")
                })}

            </div>
        );
    }
}
